import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://www.kesult.com';

export default function SEOHead({ title, description, canonical, jsonLd, lang = 'nl' }) {
  const location = useLocation();
  const path = location.pathname;

  const isEnglish = path.startsWith('/en');
  const nlPath = isEnglish ? path.replace(/^\/en/, '') || '/' : path;
  const enPath = isEnglish ? path : `/en${path === '/' ? '' : path}`;

  const selfCanonical = `${BASE_URL}${path === '/' ? '' : path}`;
  const nlUrl = `${BASE_URL}${nlPath}`;
  const enUrl = `${BASE_URL}${enPath}`;

  const pageTitle = title || 'Kesult | Freelance SEO Specialist';
  const pageDescription = description || 'Freelance SEO Specialist voor ambitieuze bedrijven in Nederland.';

  return (
    <Helmet
      htmlAttributes={{ lang: lang || 'nl' }}
      title={pageTitle}
      meta={[
        { name: 'description', content: pageDescription },
        { property: 'og:title', content: pageTitle },
        { property: 'og:description', content: pageDescription },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: selfCanonical },
        { name: 'twitter:card', content: 'summary' },
        { name: 'twitter:title', content: pageTitle },
        { name: 'twitter:description', content: pageDescription },
      ]}
      link={[
        { rel: 'canonical', href: selfCanonical },
        { rel: 'alternate', hrefLang: 'nl', href: nlUrl },
        { rel: 'alternate', hrefLang: 'en', href: enUrl },
        { rel: 'alternate', hrefLang: 'x-default', href: enUrl },
      ]}
      script={jsonLd ? [{
        type: 'application/ld+json',
        innerHTML: typeof jsonLd === 'string' ? jsonLd : JSON.stringify(jsonLd),
      }] : []}
    />
  );
}
